export const BuildInfo = {timestamp:1792430185000}
